import { Head } from "@inertiajs/react"
import { LandingFooter } from "@/components/landing/footer"
import { LandingHeader } from "@/components/landing/header"

interface TermsProps {
  effectiveDate: string
}

export default function Terms({ effectiveDate }: TermsProps) {
  return (
    <>
      <Head title="Terms of Service" />
      <div className="flex min-h-screen flex-col bg-background">
        <LandingHeader />
        <main className="mx-auto w-full max-w-3xl flex-1 px-6 py-16">
          <article className="prose prose-invert max-w-none">
            <h1>Terms of Service</h1>
            <p className="text-sm text-muted-foreground">
              Effective date: {effectiveDate}
            </p>

            <p>
              These Terms of Service ("Terms") govern your access to and use
              of AdWizard (the "Service"), operated by Bitmapped Designs
              ("we", "us"). By creating an account or using the Service you
              agree to these Terms.
            </p>

            <h2>The Service</h2>
            <p>
              AdWizard is a Model Context Protocol server that allows AI
              assistants you authorize to read from and write to your Google
              Ads accounts on your behalf. Your use of Google Ads itself is
              governed by your agreements with Google.
            </p>

            <h2>Eligibility &amp; account</h2>
            <p>
              You must be at least 18 years old and have authority to grant
              access to the Google Ads accounts you connect. You are
              responsible for activity that occurs under your account and for
              keeping your Google credentials secure.
            </p>

            <h2>Acceptable use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>
                Use the Service to violate the Google Ads API Terms or any
                applicable law.
              </li>
              <li>
                Access Google Ads accounts you are not authorized to manage.
              </li>
              <li>
                Reverse-engineer, scrape, or attempt to extract source code
                from the Service except where permitted by law.
              </li>
              <li>
                Interfere with the Service's operation, security, or other
                users.
              </li>
            </ul>

            <h2>AI assistant actions</h2>
            <p>
              When you connect an AI assistant to the Service, that assistant
              can take actions in your Google Ads accounts on your behalf —
              including but not limited to pausing or enabling campaigns,
              changing budgets, editing ad copy, and adding negative
              keywords. You are responsible for the actions you authorize.
              Review changes before confirming them when the Service prompts
              you to do so.
            </p>

            <h2>Fees</h2>
            <p>
              The Service is currently provided free of charge while in
              beta. We may introduce paid plans in the future and will give
              advance notice before any charges apply.
            </p>

            <h2>Termination</h2>
            <p>
              You may stop using the Service at any time by revoking
              AdWizard's access at{" "}
              <a
                href="https://myaccount.google.com/permissions"
                target="_blank"
                rel="noreferrer"
              >
                myaccount.google.com/permissions
              </a>{" "}
              or by emailing us to delete your account. We may suspend or
              terminate your access if you violate these Terms or if we are
              required to do so by law.
            </p>

            <h2>Disclaimers</h2>
            <p>
              The Service is provided "as is" and "as available" without
              warranties of any kind, express or implied, including
              merchantability, fitness for a particular purpose, and
              non-infringement. We do not warrant that the Service will be
              uninterrupted, error-free, or that any data returned is
              accurate or complete.
            </p>

            <h2>Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, we will not be liable
              for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of profits, revenue, data, or ad
              spend, arising out of or related to your use of the Service.
              Our total liability for any claim arising out of these Terms or
              the Service will not exceed one hundred US dollars (USD $100).
            </p>

            <h2>Indemnification</h2>
            <p>
              You agree to indemnify and hold us harmless from any claim,
              loss, or expense (including reasonable attorneys' fees) arising
              out of your misuse of the Service, your violation of these
              Terms, or your violation of any third-party rights.
            </p>

            <h2>Changes</h2>
            <p>
              We may update these Terms from time to time. We will post the
              updated version with a new effective date and, for material
              changes, give notice through the Service or by email.
              Continued use of the Service after changes take effect
              constitutes acceptance.
            </p>

            <h2>Governing law</h2>
            <p>
              These Terms are governed by the laws of the State of Florida,
              United States, without regard to its conflict-of-laws
              provisions. Disputes will be resolved in the state or federal
              courts located in Florida.
            </p>

            <h2>Contact</h2>
            <p>
              Questions about these Terms:{" "}
              <a href="mailto:colleen@bitmappeddesigns.com">
                colleen@bitmappeddesigns.com
              </a>
              .
            </p>
          </article>
        </main>
        <LandingFooter />
      </div>
    </>
  )
}
